<div class="games-running-modal-container d-flex flex-column" style="height:564px">
    <div class="modal-header my-1">
        <h8 class="modal-title lato-bold" cvLocalizedText langSection="Command_Center" langKey="Overview_Of_Games_Running">Overview of Games Running</h8>
        <select id="gamesModalDateSelector" class="form-control ml-auto mt-1 w-25" [(ngModel)]="selectedRange" (change)="buildGamesRunning()">
            <option id="gamesDateOpt_{{range.key}}" *ngFor="let range of possibleRanges" [value]="range.key">{{range.display}}</option>
        </select>
        <button id="closeGamesModalBtn" type="button" class="ml-3 close" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    
    <div class="modal-body flex-fill pt-0">
        <ag-grid-angular #gamesRunningModalGrid *ngIf="grid" [hidden]="isLoading" class="ag-theme-material lato-regular h-100 w-100 overflow-auto" [gridOptions]="grid"></ag-grid-angular>
        <div [hidden]="!isLoading">
            <cv-loader [size]="'medium'" [overlay]="true"></cv-loader>
        </div>
    </div>
</div>